module.exports = __webpack_public_path__ + "img/pointer_map.e4204514.svg";